import React from "react";
import { Outlet } from "react-router-dom";
import { BottomTabs } from "./BottomTabs";

export default function RootLayout() {
  return (
    <div className="min-h-screen pb-20">
      <Outlet />
      <BottomTabs />
    </div>
  );
}

